// extracted by mini-css-extract-plugin
export default {"box":"User_box__26L--","user":"User_user__rXljj"};